import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { setCookie, getInfoResponse } from "utils/common";
import { saveUserInfo } from "features/User/userSlice";
import { SERVICE } from "constants/global";
import newAPI from "api/newAPI";
import noticeAPI from "api/noticeAPI";
import topAPI from "api/topAPI";

const initTop = createAsyncThunk(
  "INIT_TOP",
  async (_arg, { dispatch, rejectWithValue }) => {
    try {
      setCookie("FLAG_COOKIE", true);
      const res = await Promise.all([
        topAPI.initTop(_arg),
        noticeAPI.getInitNotice({ service: SERVICE }),
        newAPI.getInitNew({ service: SERVICE }),
      ]);
      dispatch(saveUserInfo(getInfoResponse(res[0])));
      if (res[0].data.isInLine || res[0].sorrypage == '0' && res[1].sorrypage == '0' && res[2].sorrypage == '0') {
        return {
          top: {},
          notice: {},
          new: {},
          isInLine: true,
        };
      }
      return {
        top: res[0].data,
        notice: res[1].message?.notice,
        new: res[2].data?.news,
        isInLine: false,
        isInLineTop: res[0].sorrypage == '0',
        isInLineNotice: res[1].sorrypage == '0',
        isInLineNew: res[2].sorrypage == '0',
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const getPromotionsByGenre = createAsyncThunk(
  "GET_PROMOTION_GENRE",
  async (_arg, { dispatch, rejectWithValue }) => {
    try {
      const res = await topAPI.getPromotionsByGenre(_arg);
      dispatch(saveUserInfo(getInfoResponse(res)));
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const initialState = {
  genre: null,
  promotion_all: null,
  genre_init: null,
  promotion_genre: null,
  noticesInit: null,
  newsInit: null,
  isRevoke: null,
  isInLine: false
};

const topSlice = createSlice({
  name: "top",
  initialState,
  extraReducers: {
    [initTop.fulfilled]: (state, action) => {
      const { isRevoke, genre, promotion_all, ...list_genre } =
        action.payload.top;
      state.isRevoke = isRevoke;
      state.genre = genre;
      state.promotion_all = promotion_all;
      state.genre_init = Object.values(list_genre);
      state.noticesInit = action.payload.notice;
      state.newsInit = action.payload.new;
      state.isInLine = action.payload.isInLine;
      state.isInLineTop = action.payload.isInLineTop;
      state.isInLineNotice = action.payload.isInLineNotice;
      state.isInLineNew = action.payload.isInLineNew;
    },
    [getPromotionsByGenre.fulfilled]: (state, action) => {
      state.promotion_genre = action.payload.promotion;
    },
  },
});

const { reducer } = topSlice;
export { initTop, getPromotionsByGenre };
export default reducer;
